import { render, staticRenderFns } from "./gishome.vue?vue&type=template&id=77b78982&scoped=true"
import script from "./gishome.vue?vue&type=script&lang=js"
export * from "./gishome.vue?vue&type=script&lang=js"
import style0 from "./gishome.vue?vue&type=style&index=0&id=77b78982&prod&lang=less&scoped=true"
import style1 from "./gishome.vue?vue&type=style&index=1&id=77b78982&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b78982",
  null
  
)

export default component.exports